import React, { useState } from 'react';
import { motion } from 'framer-motion';
import ReviewComposer from '../../components/review-composer';
import ReviewList from '../../components/review-list';

export default function DashboardPage() {
  const [reviews, setReviews] = useState([
    { author: 'Anonymous', content: 'Great collaborator and communicator.' },
  ]);

  const addReview = (newReview) => {
    setReviews((prev) => [newReview, ...prev]);
  };

  return (
    <div className='p-6 bg-gray-50 min-h-screen'>
      <motion.h2
        className='text-3xl font-bold text-indigo-700 mb-4'
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        Your Virtual Review Space
      </motion.h2>
      <ReviewComposer onSubmit={addReview} />
      <div className='mt-6'>
        <ReviewList reviews={reviews} />
      </div>
    </div>
  );
}
